// reference https://stephanlangeveld.medium.com/simple-local-storage-implementation-using-vue-3-vueuse-and-pinia-with-zero-extra-lines-of-code-cb9ed2cce42a
import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

export const useUserStore = defineStore('user', {
  state: () => ({
    isAuthenticated: useStorage('isAuthenticated', false),
    sessionInfo: useStorage('sessionInfo', {}),
    tipsCount: useStorage('tipsCount', 0),
    // Whether the "you need to resubscribe" redirect (MenuStorageBar.vue) has
    // already been shown this login session - only forced once, so the user
    // can freely navigate away afterwards instead of being bounced back to
    // /plans on every route change.
    resubscriptionPromptShown: useStorage('resubscriptionPromptShown', false),
    // Same idea, for the earlier heads-up toast (MenuStorageBar.vue) shown to
    // clinics whose legacy subscription hasn't expired yet but will need to
    // be renewed manually - only once per login, not on every route change.
    migrationNoticeShown: useStorage('migrationNoticeShown', false),
    // TODO expiration: new Date(NEWDATE.getTime() + (30 * 60 * 1000))
  }),

  getters: {
    /*
        isAuthenticated() {
            return this.isAuthenticated
        }
    */
  },

  actions: {
    reset() {
      this.isAuthenticated = false
      this.sessionInfo = {}
      this.resubscriptionPromptShown = false
      this.migrationNoticeShown = false
    },

    loggedIn(_sessionInfo) {
      this.$patch({
        isAuthenticated: true,
        sessionInfo: _sessionInfo,
        resubscriptionPromptShown: false,
        migrationNoticeShown: false
      })

      // we could do other stuff like redirecting the user
    },

    logout() {
      this.$patch({
        isAuthenticated: false,
        sessionInfo: {},
        resubscriptionPromptShown: false,
        migrationNoticeShown: false
      })

      // we could do other stuff like redirecting the user
    },

    markResubscriptionPromptShown() {
      this.resubscriptionPromptShown = true
    },

    markMigrationNoticeShown() {
      this.migrationNoticeShown = true
    },

    termAccepted(_sessionInfo) {
      this.$patch({
        sessionInfo: _sessionInfo
      })
    },

    welcomeAccepted(_sessionInfo){
      this.$patch({
        sessionInfo: _sessionInfo
      })
    },

    incrementTipsCount(tipsCount) {
      if (tipsCount != 0)
        this.tipsCount += tipsCount
      else
        this.tipsCount = tipsCount
    },
  },
})
